<template>
  <div>
      <Header/>
      <v-overlay v-model="overlay">
      <v-progress-circular
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>
        <v-alert
            border="top"
            colored-border
            type="info"
            elevation="2"
            v-model="success"
            >
            Successfully
            </v-alert>
            <v-parallax src="../assets/fightbanner.jpg">
            <v-container>
              <v-row class="text-center" align="center" justify="center">
              <v-col class="col-12 col-sm-12 col-md-5 col-lg-5 text-center">
                <h2 class="bannerheadingh2 mb-0">{{this.viewcurrentfight.Fighter1Name}}</h2>
                <h2 class="bannerheadingh2">{{this.viewcurrentfight.Fighter1SurName}}</h2>
              </v-col>
              <v-col class="col-12 col-sm-12 col-md-2 col-lg-2">
                <h2 class="bannerheadingh2">VS</h2>
              </v-col>
              <v-col class="col-12 col-sm-12 col-md-5 col-lg-5">
                <h2 class="bannerheadingh2 mb-0">{{this.viewcurrentfight.Fighter2Name}} </h2>
                <h2 class="bannerheadingh2">{{this.viewcurrentfight.Fighter2SurName}}</h2>
              </v-col>
            </v-row>

            </v-container>
            
            </v-parallax>
      <v-container class="myfightcards">
        <v-card class="py-5 px-5 tabbackground" flat>
          <v-row class="text-center" align="center" justify="center">
            <v-col class="col-12 col-sm-12 col-md-4 col-lg-4">
              <v-card class="py-5 px-5">
                <h2>{{this.viewcurrentfight.Fighter1Name}}  {{this.viewcurrentfight.Fighter1SurName}}</h2>
                <v-avatar size="200">
                    <img :src="this.viewcurrentfight.Fighter1Image" :alt="this.viewcurrentfight.Fighter1Name" />
                </v-avatar>
                <v-row class="my-3">
                  <v-col class="col-12">
                    <country-flag rounded :country='this.viewcurrentfight.Fighter1Country' size='big'/>
                  </v-col>
                  <v-col class="col-4 text-center">
                    <div class="text-center font-weight-bold">
                      W
                    </div>
                    <div class="text-center Wins white--text py-2 records">
                      <h2>{{this.viewcurrentfight.Fighter1Wins}}</h2>
                    </div>
                    <div class="text-center WinsKO mt-2">
                      {{this.viewcurrentfight.Fighter1Wins_by_KO}} BY KO
                    </div>
                  </v-col>
                  <v-col class="col-4">
                    <div class="text-center font-weight-bold">
                      L
                    </div>
                    <div class="text-center Losses white--text py-2 records">
                      <h2>{{this.viewcurrentfight.Fighter1Losses}}</h2>
                    </div>
                    <div class="text-center LossesKO mt-2">
                      {{this.viewcurrentfight.Fighter1Losses_by_KO}} BY KO
                    </div>
                  </v-col>
                  <v-col class="col-4 text-center">
                    <div class="text-center font-weight-bold">
                      D
                    </div>
                    <div class="Draws white--text py-2 records">
                      <h2>{{this.viewcurrentfight.Fighter1Draws}}</h2>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col class="col-12 col-sm-12 col-md-4 col-lg-4 white--text hidden-sm-and-down">
              <div class="my-auto">
                <v-row class="mb-4" align="center" justify="center">
                   <v-col class="col-12">
                    <h2>Voting Starts</h2>
                    <h3 class="mb-0">{{this.viewcurrentfight.DateStart}} </h3>
                    <h3>{{this.viewcurrentfight.TimeStart}} </h3>
                  </v-col>
                  <!-- <v-col class="col-12 col-sm-12 col-md-5 col-lg-5">
                    <h1>{{this.viewcurrentfight.Fighter1Name}}</h1>
                  </v-col>
                  <v-col class="col-12 col-sm-12 col-md-2 col-lg-2">
                    <h3>VS</h3>
                  </v-col> -->
                  <v-col class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <h4>Weight Division</h4>
                    <h2 class="white--text">{{this.viewcurrentfight.Weightdivision}}</h2>
                  </v-col>
                  <v-col class="col-12">
                      <h1 class="differentfont primary--text mb-0">{{this.viewcurrentfight.Rounds}}<br>
                      Rounds
                      </h1>
                      <!-- <h2 class="differentfont">Rounds</h2> -->
                  </v-col>
                  <v-col class="col-12">
                    <h2>Voting Ends</h2>
                    <h3>{{this.viewcurrentfight.DateEnd}}</h3>
                    <h3 class="mb-0">{{this.viewcurrentfight.TimeEnd}} </h3>
                  </v-col>
                    <v-col class="col-12 text-center">
                      <ShareNetwork
                          network="facebook"
                          :url='"https://africanring.applorduat.co.za/fight/" + this.FightTitle + "/" + this.uid'
                          :title='this.viewcurrentfight.Fighter1Name + " " + this.viewcurrentfight.Fighter1SurName + " VS " + this.viewcurrentfight.Fighter2Name + " " + this.viewcurrentfight.Fighter2SurName'
                          :description='"Fight Night " + this.viewcurrentfight.Fighter1Name + " VS " + this.viewcurrentfight.Fighter2Name + ". On the "  + this.viewcurrentfight.DateStart + " @ " +  this.viewcurrentfight.TimeStart + " Voting will start for this match up. Please Visit our website to vote."'
                          :quote='this.viewcurrentfight.Fighter1Name + " " + this.viewcurrentfight.Fighter1SurName + " VS " + this.viewcurrentfight.Fighter2Name + " " + this.viewcurrentfight.Fighter2SurName'
                          hashtags="AfricanRingBoxingLegends"
                        >
                          <!-- hashtags="vuejs,vite" -->
                          <!-- <v-btn > -->
                            <v-icon size="40" class="blue--text">mdi-facebook</v-icon>
                          <!-- </v-btn> -->
                          
                      </ShareNetwork>
                      <ShareNetwork
                          network="WhatsApp"
                          :url='"https://africanring.applorduat.co.za/fight/" + this.FightTitle + "/" + this.uid'
                          :title='this.viewcurrentfight.Fighter1Name + " " + this.viewcurrentfight.Fighter1SurName + " VS " + this.viewcurrentfight.Fighter2Name + " " + this.viewcurrentfight.Fighter2SurName'
                          :description='"Fight Night " + this.viewcurrentfight.Fighter1Name + " VS " + this.viewcurrentfight.Fighter2Name + ". On the "  + this.viewcurrentfight.DateStart + " @ " +  this.viewcurrentfight.TimeStart + " Voting will start for this match up. Please Visit our website to vote."'
                          :quote='this.viewcurrentfight.Fighter1Name + " " + this.viewcurrentfight.Fighter1SurName + " VS " + this.viewcurrentfight.Fighter2Name + " " + this.viewcurrentfight.Fighter2SurName'
                        >
                          <!-- hashtags="vuejs,vite" -->
                          <!-- <v-btn > -->
                            <v-icon size="40" class="green--text">mdi-whatsapp</v-icon>
                          <!-- </v-btn> -->
                          
                      </ShareNetwork>
                    </v-col>
                </v-row>
              </div>
            </v-col>


            <v-col class="col-12 col-sm-12 col-md-4 col-lg-4 white--text hidden-lg-and-up">
              <h2 class="bannerheadingh2">VS</h2>
            </v-col>



            <v-col class="col-12 col-sm-12 col-md-4 col-lg-4">
              <v-card class="py-5 px-5">
                <h2>{{this.viewcurrentfight.Fighter2Name}}  {{this.viewcurrentfight.Fighter2SurName}}</h2>
                <v-avatar size="200">
                    <img :src="this.viewcurrentfight.Fighter2Image" :alt="this.viewcurrentfight.Fighter2Name" />
                </v-avatar>
                <v-row class="my-3">
                  <v-col class="col-12">
                    <country-flag rounded :country='this.viewcurrentfight.Fighter2Country' size='big'/>
                  </v-col>
                  <v-col class="col-4">
                    <div class="text-center font-weight-bold">
                      W
                    </div>
                    <div class="text-center Wins white--text py-2 records">
                      <h2>{{this.viewcurrentfight.Fighter2Wins}}</h2>
                    </div>
                    <div class="text-center WinsKO mt-2">
                      {{this.viewcurrentfight.Fighter2Wins_by_KO}} BY KO
                    </div>
                  </v-col>
                  <v-col class="col-4">
                    <div class="text-center font-weight-bold">
                      L
                    </div>
                    <div class="text-center Losses white--text py-2 records">
                      <h2>{{this.viewcurrentfight.Fighter2Losses}}</h2>
                    </div>
                    <div class="text-center LossesKO mt-2">
                      {{this.viewcurrentfight.Fighter2Losses_by_KO}} BY KO
                    </div>
                  </v-col>
                  <v-col class="col-4 text-center">
                    <div class="text-center font-weight-bold">
                      D
                    </div>
                    <div class="Draws white--text py-2 records">
                      <h2>{{this.viewcurrentfight.Fighter2Draws}}</h2>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col class="col-12 col-sm-12 col-md-4 col-lg-4 white--text hidden-lg-and-up">
              <div class="my-auto">
                <v-row class="mb-4" align="center" justify="center">
                   <v-col class="col-12">
                    <h2>Voting Starts</h2>
                    <h3 class="mb-0">{{this.viewcurrentfight.DateStart}} </h3>
                    <h3>{{this.viewcurrentfight.TimeStart}} </h3>
                  </v-col>
                  <v-col class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <h4>Weight Division</h4>
                    <h2 class="white--text">{{this.viewcurrentfight.Weightdivision}}</h2>
                  </v-col>
              
                  <v-col class="col-12">
                      <h1 class="differentfont primary--text mb-0">{{this.viewcurrentfight.Rounds}}<br>
                      Rounds
                      </h1>
                     
                  </v-col>
                  <v-col class="col-12">
                    <h2>Voting Ends</h2>
                    <h3>{{this.viewcurrentfight.DateEnd}}</h3>
                    <h3 class="mb-0">{{this.viewcurrentfight.TimeEnd}} </h3>
                  </v-col>
                    <v-col class="col-12 text-center">
                      <ShareNetwork
                          network="facebook"
                          :url='"https://africanring.applorduat.co.za/fight/" + this.FightTitle + "/" + this.uid'
                          :title='this.viewcurrentfight.Fighter1Name + " " + this.viewcurrentfight.Fighter1SurName + " VS " + this.viewcurrentfight.Fighter2Name + " " + this.viewcurrentfight.Fighter2SurName'
                          :description='"Fight Night " + this.viewcurrentfight.Fighter1Name + " VS " + this.viewcurrentfight.Fighter2Name + ". On the "  + this.viewcurrentfight.DateStart + " @ " +  this.viewcurrentfight.TimeStart + " Voting will start for this match up. Please Visit our website to vote."'
                          :quote='this.viewcurrentfight.Fighter1Name + " " + this.viewcurrentfight.Fighter1SurName + " VS " + this.viewcurrentfight.Fighter2Name + " " + this.viewcurrentfight.Fighter2SurName'
                        >
                   
                            <v-icon size="40" class="blue--text">mdi-facebook</v-icon>
  
                          
                      </ShareNetwork>
                      <ShareNetwork
                          network="WhatsApp"
                          :url='"https://africanring.applorduat.co.za/fight/" + this.FightTitle + "/" + this.uid'
                          :title='this.viewcurrentfight.Fighter1Name + " " + this.viewcurrentfight.Fighter1SurName + " VS " + this.viewcurrentfight.Fighter2Name + " " + this.viewcurrentfight.Fighter2SurName'
                          :description='"Fight Night " + this.viewcurrentfight.Fighter1Name + " VS " + this.viewcurrentfight.Fighter2Name + ". On the "  + this.viewcurrentfight.DateStart + " @ " +  this.viewcurrentfight.TimeStart + " Voting will start for this match up. Please Visit our website to vote."'
                          :quote='this.viewcurrentfight.Fighter1Name + " " + this.viewcurrentfight.Fighter1SurName + " VS " + this.viewcurrentfight.Fighter2Name + " " + this.viewcurrentfight.Fighter2SurName'
                        >
                          
                            <v-icon size="40" class="green--text">mdi-whatsapp</v-icon>
                          
                      </ShareNetwork>
                    </v-col>
                </v-row>
              </div>
            </v-col>

          </v-row>
        </v-card>
        <v-card class="mx-5 my-5 px-5 py-5">
          <v-row>
            <v-col v-if="this.viewcurrentfight.FightTitle" class="col-12 text-center">
              <h3>{{this.viewcurrentfight.FightTitle}}</h3>
            </v-col>
            <v-col v-if="this.viewcurrentfight.Story" class="col-12 text-center">
              <p>{{this.viewcurrentfight.Story}}</p>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mx-5 my-5 px-5 py-5">
          <v-row v-if="this.showvoting == true">
            <v-col v-if="this.votedalready == false" class="col-12 py-5 px-5 flat">
              <v-row v-if="this.show" class="text-center">
                <v-col class="col-8 mx-auto">
                  <h4>Please sign in to Vote or Register if you dont have an account.</h4>
                <v-btn color="red darken-1" text @click="$router.push('/login')">Login</v-btn>
                <v-btn color="red darken-1" text @click="$router.push('/subscribe')">Register</v-btn>
                </v-col>
              </v-row>
              <v-row v-if="this.thankyouforvoting == true">
                <v-col class="col-12 text-center">
                  <h3 class="thankyoutext">Thank you for Voting. You will be notified on the {{this.viewcurrentfight.DateStart}}.</h3>
                </v-col>
                <v-col class="col-12 text-center">
                   <v-btn
                      color="red darken-1"
                      text
                      @click="backhome()"
                    >
                      BACK HOME
                    </v-btn>
                </v-col>
              </v-row>

                <v-form v-if="!this.show && this.thankyouforvoting == false && this.votedalready == false" ref="form"
                  v-model="valid" 
                  class="row mx-auto"
                  >
                  <v-col cols="12">
                    <h2 class="text-center">Vote Now</h2>
                  </v-col>
                        <v-col
                            cols="12"
                            sm="12"
                            md="6"
                            class="mx-auto"
                          >
                          <v-select
                            v-model="winbyvote"
                            :items="winby"
                            item-text="text"
                            item-value="value"
                            :rules="[rules.required]"
                            label="Win By"
                          >
                          </v-select>
                          </v-col>
                          <v-col
                            v-if="winbyvote == 'byko' || winbyvote == 'bydecision'"
                            cols="12"
                            sm="12"
                            md="6"
                            class="mx-auto"
                          >
                          <v-select
                            v-model="winnervote"
                            :items="currentfightersinfo"
                            item-text="Fighter1Name"
                            item-value="Fighter1uid"
                            :rules="[rules.required]"
                            label="Pick Winner"
                          >
                          </v-select>
                          </v-col>
                          <v-col
                            v-if="winbyvote == 'byko'"
                            cols="12"
                            sm="12"
                            md="6"
                            class="mx-auto"
                          >
                          <v-text-field
                              :rules="[rules.required]"
                              v-model="koroundvote"
                              :label="`Choose Round from 1 - ` + this.viewcurrentfight.Rounds"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            v-if="winbyvote == 'bydecision'"
                            cols="12"
                            sm="12"
                            md="6"
                            class="mx-auto"
                          >
                          <v-text-field
                              :value="this.decisionroundvote"
                              disabled
                              v-model="decisionroundvote"
                              :label="`Max Rounds ` + this.viewcurrentfight.Rounds"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12"
                            sm="12"
                            md="12"
                            class="text-center"
                            >
                            <v-btn
                              color="red darken-1"
                              text
                              @click="submitvote()"
                              :disabled="!valid"
                            >
                              Vote Now
                            </v-btn>
                            </v-col>
                </v-form>
            </v-col>
          </v-row>

          <v-row v-if="this.showreminder == true">
            <v-col class="col-12 text-center">
                  <v-dialog 
                    v-if="!this.reminderemail"
                      v-model="dialog"
                      persistent
                      max-width="400"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          dark
                          v-bind="attrs"
                          v-on="on"
                        >
                        <v-icon left>
                          mdi-bell-plus
                        </v-icon>
                          Set Reminder
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-text class="pt-5">

                          <v-col
                          v-if="this.thecurrentuserdata"
                          cols="12"
                            sm="12"
                            md="12"
                            class="text-center"
                            >
                          <h2>Hi {{this.thecurrentuserdata}}</h2>
                          </v-col>

                          <v-col
                          v-if="!this.thecurrentuserdata"
                          cols="12"
                            sm="12"
                            md="12"
                            class="text-center"
                            >
                          <h2>You adding a reminder for this match up.</h2>
                          </v-col>

                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            v-if="this.thecurrentuserdata"
                            >
                              <v-select
                                v-model="subcribeToAll"
                                :items="whichremider"
                                item-text="text"
                                item-value="value"
                                :rules="[rules.required]"
                                label="Which Reminder"
                              >
                              </v-select>
                            </v-col>


                          <v-form 
                            v-if="!this.reminderemail && subcribeToAll == 'onlyThisOne' || !this.thecurrentuserdata"
                            ref="formreminded"
                            v-model="remindedvalid" 
                            class="row mx-auto"
                            >
                            <v-col cols="12" v-if="this.thecurrentuserdata">
                              <h4>You are adding a reminder for just this match up</h4>
                            </v-col>
                            
                                <v-col
                                      cols="12"
                                      sm="12"
                                      md="12"
                                      class="mx-auto"
                                    >
                                    <v-text-field
                                        :rules="[rules.required]"
                                        v-model="thecurrentuseremail"
                                        label="Email"
                                        :value="this.thecurrentuseremail"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12"
                                      sm="12"
                                      md="12"
                                      class="text-center"
                                      >
                                      <v-btn
                                        color="red darken-1"
                                        text
                                        @click="closedialog()"
                                      >
                                        Cancel
                                      </v-btn>
                                      <v-btn
                                        color="red darken-1"
                                        text
                                        @click="getemailforreminder()"
                                        :disabled="!remindedvalid"
                                      >
                                        Continue
                                      </v-btn>
                                  </v-col>
                          </v-form>


                          <v-form 
                          v-if="subcribeToAll == 'allMatchUps'"
                          v-model="showsubcribeToAll" 
                            ref="subcribeToAllNotifications"
                            class="row mx-auto"
                            >
                            <v-col cols="12" class="text-center">
                              <!-- <h2 class="mb-3">Hi {{this.thecurrentuserdata.displayName}}</h2> -->
                              <h4>You are adding a reminder for all upcoming match ups</h4>
                            </v-col>
                            
                                <!-- <v-col
                                      cols="12"
                                      sm="12"
                                      md="12"
                                      class="mx-auto"
                                    >
                                    <v-text-field
                                        :rules="[rules.required]"
                                        v-model="reminder"
                                        label="Email"
                                      ></v-text-field>
                                    </v-col> -->
                                    <v-col cols="12"
                                      sm="12"
                                      md="12"
                                      class="text-center"
                                      >
                                      <v-btn
                                        color="red darken-1"
                                        text
                                        @click="closedialog()"
                                      >
                                        Cancel
                                      </v-btn>
                                      <v-btn
                                        color="red darken-1"
                                        text
                                        @click="userUpdatingProfile(useruid)"
                                        :disabled="!subcribeToAllNotificationsvalidate"
                                      >
                                        Continue
                                      </v-btn>
                                  </v-col>
                          </v-form>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              <!-- <h4>Be reminded when votes open</h4> -->
                <v-row v-if="this.reminderemail == true">
                <v-col class="col-12 text-center">
                  <h3 class="thankyoutext">You will be notified on {{this.viewcurrentfight.DateStart}}.</h3>
                </v-col>
                <v-col class="col-12 text-center">
                   <v-btn
                      color="red darken-1"
                      text
                      @click="backhome()"
                    >
                      BACK HOME
                    </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="this.votedalready == true && this.showresults == false">
            <v-col class="text-center">
              <h3 class="thankyoutext">You have already voted for this fight. You will be notified when on the {{this.viewcurrentfight.DateStart}}.</h3>
            </v-col>
          </v-row>
          <v-row v-if="this.showresults == true" class="text-center">
            <v-col class="col-11 mx-auto text-center resultheading">
              <h2>Results</h2>
            </v-col>
            <v-col class="resultcol col-11 col-sm-11 col-md-3 col-lg-3 mx-auto ">
              <h2>Winner</h2>
              <h3>{{this.viewcurrentfight.Winner}}</h3>
              <!-- <h3 v-if="this.viewcurrentfight.Winner == this.viewcurrentfight.Fighter2">{{this.viewcurrentfight.Fighter2Name}} {{this.viewcurrentfight.Fighter2SurName}}</h3> -->
            </v-col>
            <v-col class="resultcol col-11 col-sm-11 col-md-3 col-lg-3 mx-auto ">
              <h2>Win By</h2>
              <h3 v-if="this.viewcurrentfight.WinBy == 'byko'">Winner By KO</h3>
              <h3 v-if="this.viewcurrentfight.WinBy == 'Decision'">Winner By Points</h3>
            </v-col>
            <v-col v-if="this.viewcurrentfight.WinBy == 'byko'" class="resultcol col-11 col-sm-11 col-md-3 col-lg-3 mx-auto ">
              <h2>Round</h2>
              <h3>{{this.viewcurrentfight.KoRoundVote}}</h3>
            </v-col>
            <v-col v-if="this.viewcurrentfight.WinBy == 'bydecision'" class="resultcol col-11 col-sm-11 col-md-3 col-lg-3 mx-auto ">
                <h2>Max Rounds</h2>
              <h3>{{this.viewcurrentfight.Rounds}}</h3>
            </v-col>
            <v-col class="resultcol col-11 col-sm-11 col-md-3 col-lg-3 mx-auto ">
              <h2>Total Votes</h2>
              <h3>{{this.viewcurrentfight.VoteCount}}</h3>
            </v-col>
          </v-row>
        </v-card>
        <!-- {{this.fight}}
        {{this.Fighter1}}
        {{this.Fighter2}} -->
      </v-container>
      <Footer/>
  </div>
</template>

<script>
import CountryFlag from 'vue-country-flag'
import moment from 'moment';
// import { doc, getDoc } from "firebase/firestore";
import Header from "../components/frontend/header.vue";
import Footer from "../components/frontend/footer.vue"
import { collection, getDocs, addDoc, updateDoc, doc, deleteDoc, getDoc, query, where, setDoc } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import 'firebase/compat/auth';
import { mapGetters } from 'vuex';
import db from "../firebaseConfig";

export default {
  props: ['uid', 'FightTitle' ,'fight'],
  data: () => ({

    object:[], // your original data
    limit: 5, // or any number you wish to limit to
    urlTitle:'',
    dialog: false,
    reminderemail: false,
    remindedvalid:false,
    valid:false,
    votedalready: false,
    url:'',
    title:'',
    Fighter1Name:'',
    Fighter1uid:'',
    currentfightersinfo: [],
    fighter1name:'',
    fighter2name:'',
    reminder:'',
    currentfight:[],
    viewcurrentfight:[],
    loaded_fightsData: {},
    selectedfighters:[],
    selectRound:'',
    success: false,
    overlay: false,
    show:'',
    winnervote:'',
    winbyvote:'',
    decisionroundvote: '',
    showvoting: false,
    showreminder: false,
    subcribeToAll:'',
    showsubcribeToAll:false,
    showresults: false,
    thankyouforvoting:false,
    thecurrentuserdata:'',
    thecurrentuseremailmodel:'',
    thecurrentuseremail:'',
    desisionvote:'',
    useruid:'',
    winby:[
      {text: 'Winner by knockout', value: 'byko'},
      {text: 'Winner on points', value: 'bydecision'},
      {text: 'Draw', value: 'draw'}
    ],
    whichremider:[
      {text: 'Just this match up', value: 'onlyThisOne'},
      {text: 'All Upcoming match ups', value: 'allMatchUps'},
    ],
    koroundvote:'',
    rules: {
          required: value => !!value || 'Required.',
         // max: value => value > 15 || 'Cant go past max rounds.',
      },
    
  }),
  created() {
    this.setgetthefightsjoin()
    // this.getthefight()
  },
  computed: {
    ...mapGetters(['fightsdata', 'user']),
  //   computedObj(){
  //   return this.limit ? this.object.slice(0,this.limit) : this.object
  // }
  },
  methods:{
    closedialog(){
      this.dialog = false,
    this.subcribeToAll=''
    },
    backhome(){
        this.$router.replace('/');
    },
    validate () {
        this.$refs.form.validate()
    },
    formremindedvalidate () {
        this.$refs.formreminded.validate()
    },
    subcribeToAllNotificationsvalidate () {
        this.$refs.subcribeToAllNotifications.validate()
    },
    async setgetthefightsjoin() {
      this.checkforcurrentuser()
      this.viewcurrentfight.Fighter1Country = ''
      this.viewcurrentfight.Fighter2Country = ''

      this.overlay = true
      let theuid = this.uid
      //console.log('theuid',theuid)
      // let fightsdata = []
      let i = 1;

      const docRef = doc(db, "fights", theuid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        // console.log("Document data:", docSnap.data());
        let fightjoin = docSnap.data();


        const fighter1 = query(
            collection(db, "fighters"),
            where("uid", "==", fightjoin.Fighter_1)
          );
        const fighter2 = query(
            collection(db, "fighters"),
            where("uid", "==", fightjoin.Fighter_2)
          );

        const Fighter1Data = await getDocs(fighter1);
        const Fighter2Data = await getDocs(fighter2);

        let selected1fighters = {
          Fighter1Name:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"]["fields"]["Name"]["stringValue"] + " " + Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"]["fields"]["Surname"]["stringValue"],
            Fighter1uid:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"]["fields"]["uid"]["stringValue"],
        }

          this.currentfightersinfo.push(selected1fighters)

        let selected2fighters = {
           Fighter1Name:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"]["fields"]["Name"]["stringValue"] + " " + Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"]["fields"]["Surname"]["stringValue"],

            Fighter1uid:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"]["fields"]["uid"]["stringValue"],
        }


        this.currentfightersinfo.push(selected2fighters)


        let loaded_fightsData = {
          Fightuid: fightjoin.uid,
          Rounds: fightjoin.Rounds,
          Weightdivision: fightjoin.Weightdivision,
          FightTitle: fightjoin.FightTitle,
          Story: fightjoin.Story,
          DateStart: fightjoin.DateStart,
          TimeStart: fightjoin.TimeStart,
          DateEnd: fightjoin.DateEnd,
          TimeEnd: fightjoin.TimeEnd,
          Winner: fightjoin.Winner,
          WinBy: fightjoin.WinBy,
          KoRoundVote: fightjoin.KoRoundVote,
          DecisionRoundVote: fightjoin.DecisionRoundVote,
          VoteCount: fightjoin.VoteCount,
          Fighter1: fightjoin.Fighter_1,
          Fighter1Name:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Name"]["stringValue"],
          Fighter1Image:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Image"]["stringValue"],
          Fighter1ImageName:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["ImageName"]["stringValue"],
          Fighter1Percentage:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Percentage"]["stringValue"],
          Fighter2: fightjoin.Fighter_2,
          Fighter1SurName:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Surname"]["stringValue"],
            Fighter1Country:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["countries"]["stringValue"],
            Fighter1Wins:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Wins"]["stringValue"],
            Fighter1Wins_by_KO:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Wins_by_KO"]["stringValue"],
            Fighter1Losses:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Losses"]["stringValue"],
            Fighter1Losses_by_KO:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Losses_by_KO"]["stringValue"],
            Fighter1Draws:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Draws"]["stringValue"],



          Fighter2: fightjoin.Fighter_2,
          Fighter2Name:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Name"]["stringValue"],
          Fighter2SurName:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Surname"]["stringValue"],
          Fighter2Percentage:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Percentage"]["stringValue"],
          Fighter2Image:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Image"]["stringValue"],
          Fighter2ImageName:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["ImageName"]["stringValue"],
            Fighter2Country:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["countries"]["stringValue"],
            Fighter2Wins:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Wins"]["stringValue"],
            Fighter2Wins_by_KO:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Wins_by_KO"]["stringValue"],
            Fighter2Losses:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Losses"]["stringValue"],
            Fighter2Losses_by_KO:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Losses_by_KO"]["stringValue"],
            Fighter2Draws:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Draws"]["stringValue"],



        };

         this.currentfight.push(loaded_fightsData)
         

         this.viewcurrentfight = this.currentfight[0]

        //  this.urlTitle = this.viewcurrentfight.FightTitle.replaceAll(' ', '-').toLowerCase();
        //  console.log('this.urlTitle', this.FightTitle)

         this.decisionroundvote = this.viewcurrentfight.Rounds

          let now = moment()

          let startTimes = this.viewcurrentfight.TimeStart
          let endTimes = this.viewcurrentfight.TimeEnd

          let selectedfightdatestart = moment(this.viewcurrentfight.DateStart + " " + startTimes, "dddd, MMMM Do YYYY" + " " + 'HH:mm')
          let selectedfightdateend = moment(this.viewcurrentfight.DateEnd + " " + endTimes, "dddd, MMMM Do YYYY" + " " + 'HH:mm')

          if(selectedfightdatestart < now && selectedfightdateend < now ) {
            this.showresults = true
          }else if(selectedfightdatestart > now) {
            // console.log('selectedfightdatestart > now', selectedfightdatestart > now)
            this.showreminder = true
          }else{
            this.showvoting = true
          }

         //console.log("this.currentfight", this.viewcurrentfight);
          this.overlay = false

      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }

    },
    async submitvote() {
      let myuser = this.uid
      if(this.winbyvote == 'byko'){
        //console.log('test byko')
        const docRef = await addDoc(collection(db, "votes"), {
          fightuid: this.uid,
          useruid: this.user.uid,
          winner: this.winnervote,
          winbyvote: this.winbyvote,
          koroundvote: this.koroundvote,
          decisionroundvote: ''
        });
      }else if(this.winbyvote == 'bydecision'){
        //console.log('test bydecision')
        const docRef = await addDoc(collection(db, "votes"), {
          fightuid: this.uid,
          useruid: this.user.uid,
          winner: this.winnervote,
          winbyvote: this.winbyvote,
          koroundvote: '',
          decisionroundvote: this.decisionroundvote
        });
      }else {
        //console.log('test draw')
        const docRef = await addDoc(collection(db, "votes"), {
          fightuid: this.uid,
          useruid: this.user.uid,
          winner: this.winnervote,
          winbyvote: this.winbyvote,
          koroundvote: '',
          decisionroundvote:''
        });
      }
      //console.log('myuser', myuser)
      // Add a new document with a generated id.
        // this.success = true
       // console.log("Document written with ID: ", docRef.id);
        this.thankyouforvoting = true

        this.winnervote = ""
        this.winbyvote = "",
        this.winby = '',
        this.koroundvote = '',
        this.decisionroundvote =''
    },
    async getemailforreminder() {
        let dateadded = moment().toISOString()

        //console.log('this.thecurrentuseremail', this.thecurrentuseremail)

      // Add a new document with a generated id.
        const docRef = await addDoc(collection(db, "reminders"), {
          fightuid: this.uid,
          reminder: this.thecurrentuseremail,
          dateadded: dateadded
        });
        this.dialog = false
        this.reminderemail = true

        this.reminder = ''
    },
    checkforcurrentuser() {
        // const currentUser = firebase.auth().currentUser;
        //console.log('testing')
        const auth = getAuth();
        onAuthStateChanged(auth, (user) => {
          if (user) {
            this.useruid = user.uid
            this.thecurrentuserdata = user.displayName
            this.thecurrentuseremail = user.email
            // console.log('user', user)
            let myyyy = user.uid
            //console.log('user', myyyy)
            this.checkifuserhasvoted()
            // this.userUpdatingProfile(this.thecurrentuseremail)
            this.show = false
            this.showsubcribeToAll = true
            // ...
          } else {
            this.show = true
            // User is signed out
          //  console.log('out')
          }
        });
    },
    async checkifuserhasvoted() {
      const q = query(collection(db, "votes"), where("fightuid", "==", this.uid));
      // console.log('q',q)
        const querySnapshot = await getDocs(q);
        // console.log('querySnapshot', querySnapshot)
        this.votedalready = false
        querySnapshot.forEach((doc) => {
          let usershasvoted = doc.data()
          // console.log('usershasvoted.useruid', usershasvoted.useruid)
          // console.log('this.useruid', this.useruid)
          // console.log('usershasvoted', usershasvoted)
          // console.log('usershasvoted.useruid == this.useruid', usershasvoted.useruid == this.useruid)

          if(usershasvoted.useruid == this.useruid) {
            this.votedalready = true
            //console.log("set true")
            
            
          }
          // doc.data() is never undefined for query doc snapshots
         
        });
    },
    userUpdatingProfile(useruid){
      const theUserToUpdate = doc(db, 'users', useruid);

      //console.log('cityRef', theUserToUpdate)
      setDoc(theUserToUpdate, { subcribeToAllNotifications: true }, { merge: true });
      this.dialog = false
      this.reminderemail = true

    }

  },
  components:{
    Header,
    Footer,
    CountryFlag
  }
}
</script>

<style lang="sass">
.myfightcards
  min-height: 500px

.records 
  border-radius: 10px

.WinsKO 
  font-weight: bold  

.LossesKO 
  font-weight: bold  

.differentfont 
  font-family: 'Inconsolata'
  font-weight:  bold
  font-size: 60px
  text-transform: uppercase
  line-height: 60px

// @media (min-width: 900) 
//   .mobile 
//     display: block !important
  
.resultheading 
  border-bottom: 1px solid #3e3e3e

@media (max-width: 900px)
  .resultcol  
    border-bottom: 1px solid #e3e3e3
</style>